// ─── Signalement d'un message (Core) ──────────────────────────────
// Un signalement est une DEMANDE D'ARBITRAGE, pas une décision : le message
// reste visible de tous tant que personne n'a tranché. Les décisions
// (modération, suppression) vivent dans `affichageMessage.js`.
//
// Un message SIGNALÉ reste visible de tous : c'est une demande d'arbitrage, pas
// encore une modération. Il ne compte que s'il n'est ni modéré ni supprimé.
//
// En base : signale = { le, uids: [...], details: [{ par, source, motif, le }] }
//   `uids`    — qui a signalé, pour empêcher le doublon (et interroger au besoin)
//   `details` — le POURQUOI, ce qui permet d'arbitrer sans deviner
//   `source`  — 'membre' | 'ia'
//
// La source existe dès maintenant parce qu'une modération automatique est
// prévue (Cédric, 09/08 : « ça permettra par la suite d'intégrer une IA de
// modération pour avertir le modérateur d'un problème »). Un signalement
// automatique n'a pas d'uid de membre : le réduire à une liste d'uid aurait
// fermé la porte. On prépare la place, on ne construit pas l'IA.
export const SOURCE_MEMBRE = 'membre';
export const SOURCE_IA = 'ia';

// `uids` sert UNIQUEMENT à empêcher le doublon — il n'est JAMAIS affiché.
// Cédric, 09/08 : « on ne voit pas qui a signalé, sauf dans le cas de l'IA ».
// Dans un foyer, révéler l'auteur d'un signalement change la nature de l'outil.
// Seule la SOURCE se montre, et elle n'est parlante que pour l'IA.
export const signalePar = (msg) => (msg?.signale?.uids || []);
export const detailsSignalement = (msg) => (msg?.signale?.details || []);
export const signaleParIA = (msg) =>
  detailsSignalement(msg).some(d => d.source === SOURCE_IA);
export const signaleParMembre = (msg) =>
  signalePar(msg).length > 0 || detailsSignalement(msg).some(d => d.source === SOURCE_MEMBRE);

// Un signalement LEVÉ ne compte plus, mais reste inscrit : sans ça, `uids`
// repartirait à zéro et le même membre pourrait re-signaler en boucle.
export const estSignale = (msg) =>
  (signalePar(msg).length > 0 || detailsSignalement(msg).length > 0)
  && !msg?.signale?.leve && !msg?.modere && !msg?.supprime;

// Ce qu'on peut MONTRER d'un signalement : les motifs et les sources, jamais
// les identités. Réservé à ceux qui arbitrent (admin, et auteur pour un
// signalement humain).
export const signalementAffichable = (msg) =>
  detailsSignalement(msg).map(({ source, motif, le }) => ({ source, motif, le }));

// Entrée de signalement, quelle que soit son origine. Le motif est facultatif
// pour un membre (il peut signaler sans argumenter), attendu d'une IA.
export function entreeSignalement({ par, parNom, motif, source = SOURCE_MEMBRE, le }) {
  return { par: par || null, parNom: parNom || '', motif: (motif || '').trim(), source, le };
}

